import { FileText } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { CHAPERON, CHAPERON_IMG, NOTE_DOCS, NOTES } from "./notesContent";
import { SectionShell, Zoomable } from "./blocks";
import { useInView } from "./useInView";

const Chaperon = () => (
  <div className="grid lg:grid-cols-[1fr_360px] gap-12 items-start">
    <div className="mm-body space-y-4 max-w-[62ch]">
      <p className="mm-lab text-mm-golddark">{CHAPERON.kicker}</p>
      <h2 className="disp mm-h2">{CHAPERON.title}</h2>
      {CHAPERON.paras.map((p) => <p key={p}>{p}</p>)}
      <p className="disp text-3xl md:text-4xl text-mm-red pt-2" data-testid="chaperon-end">{CHAPERON.end}</p>
    </div>
    <Zoomable src={CHAPERON_IMG} alt="Note d'humour de l'enfant rebelle — le Petit Chaperon rouge" testid="chaperon-img" />
  </div>
);

const Note = ({ n }) => {
  const doc = NOTE_DOCS.find((d) => d.id === n.id);
  return (
    <article className="grid lg:grid-cols-[1fr_300px] gap-10 pt-8" data-testid={`note-${n.id}`}>
      <div className="mm-body space-y-4 max-w-[64ch]">
        <p className="mm-lab text-mm-golddark">{n.kicker}</p>
        <h3 className="disp text-3xl md:text-4xl">{n.title}</h3>
        {n.paras.map((p) => <p key={p}>{p}</p>)}
        <p className="italic pt-4 border-t border-mm-ink/20">{n.end}</p>
      </div>
      <aside className="space-y-6">
        <blockquote className="disp text-2xl leading-tight border-l-4 border-mm-red pl-4">{n.quote}</blockquote>
        <a href={doc.url} target="_blank" rel="noopener noreferrer" data-testid={`note-${n.id}-pdf`} className="inline-flex items-center gap-2 bg-mm-ink text-mm-paper px-5 py-3 font-bold hover:bg-mm-red transition-colors">
          <FileText className="w-4 h-4" /> Lire la note complète (PDF)
        </a>
      </aside>
    </article>
  );
};

export const Notes = () => {
  const [ref, cls] = useInView(0.05);
  return (
    <SectionShell id="notes" label="Notes · réflexions" bg="bg-mm-paper" innerRef={ref} cls={cls}>
      <Chaperon />
      <div>
        <h2 className="disp mm-h2">Notes de La Grande Question</h2>
        <Tabs defaultValue={NOTES[0].id} className="mt-8">
          <TabsList className="h-auto flex flex-wrap justify-start gap-2 bg-transparent p-0 rounded-none">
            {NOTES.map((n) => (
              <TabsTrigger key={n.id} value={n.id} data-testid={`note-tab-${n.id}`}
                className="rounded-none border-2 border-mm-ink px-4 py-2 font-bold text-mm-ink data-[state=active]:bg-mm-ink data-[state=active]:text-mm-paper data-[state=active]:shadow-none transition-colors">
                {n.tab}
              </TabsTrigger>
            ))}
          </TabsList>
          {NOTES.map((n) => <TabsContent key={n.id} value={n.id}><Note n={n} /></TabsContent>)}
        </Tabs>
      </div>
    </SectionShell>
  );
};
